import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHomebrewComponent } from './simple-icons-homebrew.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHomebrewComponent ],
    exports:      [ SimpleIconsHomebrewComponent ],
    bootstrap:    []
})
export class SimpleIconsHomebrewModule {}
